import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue3 from 'bootstrap-vue-3'
import { bsDropdownFixed } from "./directives/bsDropdownFixed";
import VueAxios from 'vue-axios'
import axios from 'axios'
import "./assets/css/bootstrap.min.css";
import 'v-calendar/dist/style.css';
import "./assets/css/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css"
import "vue-multiselect/dist/vue-multiselect.css"
import "./assets/css/multiselect.css";
import Notifications from '@kyvg/vue3-notification'
import { vMaska } from "maska"
import {helper} from "./service/CommonHelper";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import {UserPermission} from "@/models/enum/UserPermission";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

helper.setLang(store.getters.lang)
helper.setPhoneCodes(require('@/assets/phonecodes.json'))
window.API_URL = process.env.VUE_APP_API_URL as string
axios.defaults.baseURL = window.API_URL;
axios.defaults.headers.common = {
  'Content-Type': 'application/json;charset=UTF-8',
  'X-GA-ID': process.env.VUE_APP_X_GA_REF as string
}

const fpPromise = FingerprintJS.load().then(fp => fp.get()).then(result => {
  axios.defaults.headers.common['X-Fingerprint'] = result.visitorId
})

axios.interceptors.request.use(async (config) => {
  await fpPromise
  return config
})


router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.meta.roles.indexOf(store.getters.getRole) === -1) {
        next('/login');
        return;
      }

      if (to.name === 'routing' && store.getters.hasPermission(UserPermission.HIDE_ROUTING_SECTION)) {
        next('/login');
        return;
      }

      if (to.name === 'statistic' && store.getters.hasPermission(UserPermission.HIDE_STATISTICS_SECTION)) {
        next('/login');
        return;
      }

      if (!to.query.storeId) {
        store.dispatch("merchantStores/setCurrentStore", null)
      } else {
        await store.dispatch("merchantStores/loadCurrentStore", parseInt(to.query.storeId as string));
      }
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

createApp(App)
    .directive("maska", vMaska)
    .use(VueAxios, axios)
    .use(BootstrapVue3)
    .directive("bs-dropdown-fixed", bsDropdownFixed)
    .use(Notifications)
    .use(store)
    .use(router)
    .component(VueQrcode.name, VueQrcode)
    .mount('#app')
